import React from 'react';
import ConfettiAnimation from './ConfettiAnimation';

const Phase2CompletionModal = ({ isOpen, onClose, onCompleteOnboarding }) => {
  if (!isOpen) return null;

  const modalStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
  };

  const contentStyle = {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: window.innerWidth < 768 ? '32px 24px' : '48px',
    maxWidth: '600px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.2)',
    animation: 'slideUp 0.5s ease-out',
  };

  const titleStyle = {
    fontSize: window.innerWidth < 768 ? '28px' : '36px',
    fontWeight: '700',
    color: '#003366',
    marginBottom: '12px',
    marginTop: '0',
  };

  const emojiStyle = {
    fontSize: '80px',
    marginBottom: '20px',
    display: 'block',
    animation: 'bounce 1s ease-in-out 3',
  };

  const subtitleStyle = {
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    color: '#666',
    marginBottom: '20px',
    lineHeight: '1.6',
  };

  const progressStyle = {
    backgroundColor: '#f0f7ff',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '30px',
    border: '2px solid #007bff',
  };

  const bulletStyle = {
    textAlign: 'left',
    fontSize: window.innerWidth < 768 ? '14px' : '15px',
    color: '#333',
    margin: '12px 0',
  };

  const buttonStyle = {
    padding: window.innerWidth < 768 ? '14px 16px' : '14px 32px',
    backgroundColor: '#28a745',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontSize: window.innerWidth < 768 ? '15px' : '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    width: window.innerWidth < 768 ? '100%' : 'auto',
    marginTop: '20px',
  };

  const handleCompleteOnboarding = async () => {
    if (onCompleteOnboarding) {
      await onCompleteOnboarding();
    }
  };

  return (
    <div style={modalStyle} onClick={onClose}>
      <ConfettiAnimation isActive={isOpen} duration={3000} />

      <div style={contentStyle} onClick={(e) => e.stopPropagation()}>
        <span style={emojiStyle}>🚀</span>

        <h2 style={titleStyle}>You're Ready to Grow!</h2>

        <p style={subtitleStyle}>
          You've completed Phase 2 and mastered SwiftBidPro's advanced features. You're now fully equipped to manage your quotes, appointments, and proposals like a pro!
        </p>

        <div style={progressStyle}>
          <h4 style={{ margin: '0 0 16px 0', color: '#007bff', fontSize: '16px', fontWeight: '600' }}>
            ✓ Phase 2 Completed
          </h4>
          <div style={bulletStyle}>
            ✓ Scheduled appointments with clients
          </div>
          <div style={bulletStyle}>
            ✓ Created reusable section templates
          </div>
          <div style={bulletStyle}>
            ✓ Used templates to streamline quoting
          </div>
          <div style={bulletStyle}>
            ✓ Customized email templates with branding
          </div>
          <div style={bulletStyle}>
            ✓ Received first proposal acceptance
          </div>
        </div>

        <p style={{ ...subtitleStyle, marginBottom: '0', color: '#555' }}>
          Your onboarding is complete! You now have all the tools to succeed. Explore your dashboard and start building your business.
        </p>

        <button
          style={buttonStyle}
          onClick={handleCompleteOnboarding}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#218838';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 8px 16px rgba(40, 167, 69, 0.3)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#28a745';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = 'none';
          }}
        >
          Start Using SwiftBidPro
        </button>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes bounce {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.1);
          }
        }
      `}</style>
    </div>
  );
};

export default Phase2CompletionModal;
